import * as React from 'react';

export interface ICountdownProps {
  /** оставшееся время в секундах */
  timeLeft: number;
}

export interface ICountdownTimerProps {
  /** renderProps */
  children?(props: ICountdownProps): React.ReactElement;
  /** callback исполняемый по истечению таймаута */
  onTimeoutExpired?(): void;
  /** сколько нужно отсчитывать */
  timeout: number;
  /** момент времени от которого идет отсчет - числовое представление Date.getTime() */
  fromTimestamp: number;
}

function calculateTimeLeft(fromTimestamp: number, timeout: number) {
  const difference = fromTimestamp - new Date().getTime() + timeout * 1000;

  if (difference > 0) {
    return Math.round(difference / 1000);
  }

  return 0;
}

export function CountdownTimer({ children, fromTimestamp, timeout, onTimeoutExpired }: ICountdownTimerProps) {
  const timerRef = React.useRef<number | undefined>();
  const [timeLeft, setTimeLeft] = React.useState(() => calculateTimeLeft(fromTimestamp, timeout));

  React.useEffect(() => {
    timerRef.current = window.setTimeout(() => {
      setTimeLeft(calculateTimeLeft(fromTimestamp, timeout));
    }, 1000);

    return () => {
      window.clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, fromTimestamp]);

  React.useEffect(() => {
    if (timeLeft === 0 && onTimeoutExpired) {
      onTimeoutExpired();
    }
  }, [timeLeft, onTimeoutExpired]);

  if (!fromTimestamp || !timeout || !timeLeft) {
    return null;
  }

  if (children) {
    return children({ timeLeft });
  }

  return <span>{timeLeft}</span>;
}
